import Component from './SecurePasswordAnimation.vue';

export default Component;
